

import colors from "../../utils/colors";
import { createUseStyles } from 'react-jss';

var styles = {
  show: {
    display: 'block'
  },
  hide: { display: 'none' },
  backdrop: function backdrop(props) {return {
      background: {
        color: 'rgba(0,0,0,0.25)'
      },
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: props.zIndex || 1000,
      width: '100%',
      height: '100%',
      cursor: props.closable === false ? 'not-allowed' : 'pointer'
    };},
  modal: function modal(props) {return {
      zIndex: props.zIndex ? props.zIndex + 1 : 1001,
      background: {
        color: '#ffffff'
      },
      maxWidth: props.width || '72rem',
      maxHeight: '80vh',
      margin: {
        top: '10vh',
        left: 'auto',
        right: 'auto'
      },
      borderRadius: '10px',
      overflowY: 'auto',
      position: 'relative',
      padding: '0rem 4rem 4rem',
      cursor: 'initial'
    };},
  iconWrapper: {
    position: 'absolute',
    width: '2.4rem',
    height: '2.4rem',
    left: '3rem',
    top: '3rem',
    cursor: 'pointer',
    '&:focus': {
      outline: {
        style: 'solid',
        width: '0.2rem',
        color: colors.neutral[700]
      },
      outlineOffset: '0.1rem'
    }
  },
  closeIcon: {
    pointerEvents: 'none'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map